import Login from "../views/LoginView.vue";
import Escritorio from "../views/EscritorioView.vue";

const routes = [
  { name: "login", path: "/", component: Login },
  { name: "escritorio", path: "/escritorio", component: Escritorio },
];

export default routes;
